export default __webpack_public_path__ + "static/walk02-61f842712da0711ed966eaec954b6a7d.png";